<page-data-manager>
  <div class="flash-message-container">
    <flash-message></flash-message>
  </div>

  <div class="row">
    <div class="col-xs-12">
      <div class='page-header'>
        <div class='btn-toolbar pull-right'>
          <div class='btn-group'>
            <a class="btn btn-primary btn-sm btn-action" ng-click="colheitas.new()" uib-tooltip="Registrar colheita" tooltip-placement="left" ng-if="permissions.colheitas.canManage">
              Registrar <i class="fa fa-plus"></i>
            </a>
          </div>
        </div>
        <h2>Colheitas</h2>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-xs-12">
      <div class="panel panel-default">
        <div class="panel-heading">
          Filtros
        </div>
        <div class="panel-body">
          <form>
            <div class="row">
              <div class="col-xs-12 col-md-3">
                <label for="select-safra">Selecionar safra</label>
                <select id="select-safra" ng-model="colheitas.filters.safra" ng-options="safra.descricao for safra in safras track by safra.id" class="form-control cultura-select-safra" ng-change="changedSafra()"></select>
              </div>

              <div class="col-xs-12 col-md-3">
                <label>Talhão</label>
                <ui-select ng-model="colheitas.filters.gleba" theme="bootstrap">
                  <ui-select-match allow-clear="true" placeholder="">{{$select.selected.descricao}}</ui-select-match>
                  <ui-select-choices repeat="gleba in colheitas.glebas | filter: $select.search">
                    <span class="form-group" ng-bind-html="gleba.descricao | highlight: $select.search"></span>
                  </ui-select-choices>
                </ui-select>
              </div>

              <div class="col-xs-12 col-md-3">
                <label>Atividade</label>
                <ui-select ng-model="colheitas.filters.atividade" theme="bootstrap">
                  <ui-select-match allow-clear="true" placeholder="">{{$select.selected.descricao}}</ui-select-match>
                  <ui-select-choices repeat="atividade in colheitas.atividades | filter: $select.search">
                    <span class="form-group" ng-bind-html="atividade.descricao | highlight: $select.search"></span>
                  </ui-select-choices>
                </ui-select>
              </div>

              <div class="col-xs-12 col-md-3">
                <label>&nbsp;</label><br>
                <button class="btn btn-success" ng-click="colheitas.search()">
                  Buscar <i class="fa fa-search"></i>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-12" ng-show="colheitas.colheitas">
      <div class="panel panel-default">
        <div class="panel-heading">Colheitas</div>
        <div class="panel-body">
          <small ng-show="colheitas.colheitas.length == 0">Nenhum registro encontrado!</small>
          <table class="table table-hover table-striped" ng-show="colheitas.colheitas.length > 0">
            <thead>
              <tr>
                <th class="col-xs-3">Talhão</th>
                <th class="col-xs-3">Cultivar</th>
                <th class="col-xs-3">Área</th>
                <th class="col-xs-1">Total colhido</th>
                <th class="col-xs-1"></th>
              </tr>
            </thead>
            <tbody>
              <tr ng-repeat="colheita in colheitas.colheitas track by $index">
                <td class="vertical-middle">{{colheita.gleba.descricao | capitalize}}</td>
                <td class="vertical-middle">{{colheita.insumo.descricao | capitalize}}</td>
                <td class="vertical-middle">{{colheita.area_total_ha | number:2}}ha</td>
                <td ng-if="!colheitas.isCana(colheita)" class="vertical-middle">{{colheita.total_colhido_kg | number:2}}kg</td>
                <td ng-if="colheitas.isCana(colheita)" class="vertical-middle">{{colheita.total_colhido_ton | number:2}}ton</td>
                <td class="vertical-middle text-right">
                  <div class="btn btn-primary btn-sm" ng-if="permissions.colheitas.canRead" ng-click="colheitas.show($index)" uib-tooltip="Visualizar" tooltip-placement="top">
                    <i class="glyphicon glyphicon-eye-open"></i>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</page-data-manager>
